import React, { useCallback, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import BulkBuy from '../../../components/cot-alert-bulk-buy/bulkBuy';
import BulkAllocate from '../../../components/cot-alert-bulk-allocate/bulkAllocate';
import ProductDataFilter from '../../../components/product-data-filter/product-data-filter'
import S3Modal from '../../../components/s3Modal/S3Modal'
import GenericDataChart from '../../../GenericPageElements/GenericDataChart'
import GenericDataRow from '../../../GenericPageElements/GenericDataRow'
import GenericPageContainer from '../../../GenericPageElements/GenericPageContainer'
import GenericProductFilterContainer from '../../../GenericPageElements/GenericProductFilterContainer'
import endpoints from '../../../helpers/endpoints'
import hasPermission from '../../../helpers/permissions';
import request from '../../../helpers/request'
import session from '../../../stores/session'
import { CustomizedAxisTickMultiLine, Label } from "../../../components/GraphComponents";
import './SmartMeterRollout.scss';
import { UnallocateModal } from '../VacantCOTAlerts/vacantCOTAlerts';
import { useTranslations } from '../../../helpers/hooks';

export default function SmartMeterRolloutSummary() {
  const [groupings, setGroupings] = useState([]);
  const [group, setGroup] = useState('Type_Flag');
  const [data, setData] = useState(null);
  const [filters, setFilters] = useState({})
  const [date, setDate] = useState(null);
  const [dates, setDates] = useState([])
  const [bulkModel, setBulkModel] = useState('')
  const [S3Model, setS3Model] = useState(null);
  const translations = useTranslations('smart_meter_rollout');

  const applyFilter = (column, value) => {
    setFilters((current) => {
      return {
        ...current,
        [column]: value,
      };
    });
  };

  useEffect(() => {
    request(true)
      .get(endpoints.SMART_METER_ROLLOUT_GROUPINGS)
      .then(e => {
        setGroupings(e.data);
        setGroup(e.data.find(_ => _.default)?.target_column)
      })
  }, [])

  const getData = useCallback(() => {
    request(true).get(endpoints.SMART_METER_ROLLOUT_DATA, {
      params: {
        date: date,
        filter: filters,
        group: group ?? 'Occupier_Score',
      },
      doesCancel: true,
    })
    .then((e) => {
      setData(e.data);
    });
  }, [group, filters, date])

  useEffect(() => {
    getData()
  }, [group, filters, date]);

  useEffect(() => {
    request(true)
      .get(endpoints.SMART_METER_ROLLOUT_DATES)
      .then((e) => {
        setDates(e.data.dates);
        if (e.data.dates.length > 0) setDate(e.data.dates[0].raw);
      });
  }, []);
  return [
    <GenericPageContainer
      title={'Smart Meter Rollout'}
      className={'smart-meter-rollout'}
      titleIconClass='fak fa-id-business-icon fa-2x colour-primary'
      titleRight={<div>
        {hasPermission('SMART_METER_ROLLOUT', 'DOWNLOAD') ? (
          <button className="navigate" onClick={() => setS3Model("download")}>
            Download Return File
          </button>
        ) : null}
        {hasPermission('SMART_METER_ROLLOUT', 'UPLOAD') ? (
          <button className="navigate" onClick={() => setS3Model("upload")}>
            Issue Input File
          </button>
        ) : null}
        <Link className="navigate" to="/portal/smart-meter-rollout/search">
            To Search
        </Link>
        { (hasPermission('SMART_METER_ROLLOUT', 'WORKFLOW')) ?
            <Link className="navigate" to="/portal/smart-meter-rollout/workflow">
                To Workflow
            </Link>
        : null }
      </div>}
    >
    <div style={{maxWidth: '20vw', marginBottom: 15}}>
    <GenericDataRow title={translations['Refresh_Date']} contentColour={"white"}>
      <select
        onChange={(_) => setDate(_.target.value)}
        value={date}
        style={{
          width: "100%",
          height: "100%",
          border: "none",
          backgroundColor: "white",
          paddingLeft: "10px",
        }}
      >
        {dates.map((item) => {
          return (
            <option key={item.raw} value={item.raw}>
              {item.pretty}
            </option>
          );
        })}
      </select>
    </GenericDataRow>
    </div>
      <div class="summary-table">
      <GenericDataChart
          groupingsEndpoint={endpoints.SMART_METER_ROLLOUT_GROUPINGS}
          data={data}
          dataReady={!!data}
          selectedGroupBy={group}
          setSelectectGroupBy={setGroup}
          overrideTableHeader="Occupier Score"
          sizes={{chart: 600, chartContainer: 625, chartXAxisFontSize: 12, wrapperStyle: { paddingTop: '40px' }}}
          xAxisProps={{interval: 0}}
          customBarTick={<Label />}
          starColumnHeaders
      ></GenericDataChart>
      <GenericProductFilterContainer clearFilters={() => setFilters({})}>
          <ProductDataFilter
            filterState={filters}
            applyFilter={applyFilter}
            dataFilterEndpoint={endpoints.SMART_METER_ROLLOUT_FILTERS}
          />
          <div className='grid grid-columns-2 grid-gap-5 mta'>
              { (hasPermission('SMART_METER_ROLLOUT', 'BULK-BUY')) ?
                  <button className="button bulk-buy-button compact smaller-text" onClick={() => setBulkModel('purchase')}>
                      Create Download File
                  </button>
              : '' }
              <div className='grid grid-gap-5'>
                { (hasPermission('SMART_METER_ROLLOUT', 'ALLOCATE')) ?
                    <button className="button bulk-buy-button compact smaller-text" onClick={() => setBulkModel('allocate')}>
                        Allocate Cases
                    </button>
                : '' }
                { (hasPermission('SMART_METER_ROLLOUT', 'UNALLOCATE')) ?
                    <button className="button bulk-buy-button compact smaller-text" onClick={() => setBulkModel('unallocate')}>
                        Unallocate Cases
                    </button>
                : '' }
              </div>
              { (hasPermission('SMART_METER_ROLLOUT', 'PRIORITY-ALLOCATE')) ?
                  <button className="button bulk-buy-button compact" onClick={() => setBulkModel('priority')}>
                      Priority Allocate
                  </button>
              : '' }
                  { (hasPermission('SMART_METER_ROLLOUT', 'PRIORITY-UNALLOCATE')) ?
                  <button className="button bulk-buy-button compact" onClick={() => setBulkModel('priority-unallocate')}>
                      Priority Unallocate
                  </button>
              : '' }
          </div>
      </GenericProductFilterContainer>
      </div>
    </GenericPageContainer>,
    <S3Modal
      closeModal={() => setS3Model(null)}
      modalMode={S3Model}
      showModal={!!S3Model}
      listingUrl={endpoints.SMART_METER_ROLLOUT_FILES}
      uploadUrl={endpoints.SMART_METER_ROLLOUT_FILES}
    />,
    <BulkBuy
    SentenceFirst={({count}) => <>The selected data set includes {count} accounts to be downloaded. Press the 'Create File' button to create the download file and you will receive an email notification once this is available. Alternatively press the 'Cancel' button to go back to the summary screen.</>}
    SentenceSecond={() => <></>}
    buyButtonText="Create File" completeOnFirstStep={true} workflowUsersEndpoint={endpoints.SMART_METER_ROLLOUT_WF_USERS} bulkEndpoint={endpoints.SMART_METER_ROLLOUT_BULK_BASE} modalIsOpen={bulkModel === 'purchase'} closeModal={() => setBulkModel('')} filters={filters} date={date} />,
    <BulkAllocate 
        workflowUsersEndpoint={endpoints.SMART_METER_ROLLOUT_WF_USERS} 
        bulkEndpoint={endpoints.SMART_METER_ROLLOUT_BULK_BASE} 
        unallocateEndpoint={endpoints.SMART_METER_ROLLOUT_UNALLOCATE_GET} 
        modalIsOpen={bulkModel === 'allocate' || bulkModel === 'unallocate'} 
        mode={bulkModel} 
        closeModal={() => setBulkModel('')} 
        filters={filters} 
        date={date} 
        reallocate={bulkModel === "unallocate" && hasPermission('SMART_METER_ROLLOUT', 'ALLOCATE') && hasPermission('SMART_METER_ROLLOUT', 'UNALLOCATE')}
    />,
    <BulkAllocate workflowUsersEndpoint={endpoints.SMART_METER_ROLLOUT_WF_USERS} bulkEndpoint={endpoints.SMART_METER_ROLLOUT_BULK_BASE} urlParams={{priority: 'yes'}} modalIsOpen={bulkModel === 'priority'} closeModal={() => setBulkModel('')} filters={filters} mode={'priority allocate'} date={date} priority={true} />,
    <UnallocateModal
        modalIsOpen={bulkModel === 'priority-unallocate'} 
        closeModal={() => setBulkModel('')}
        date={date}
        filters={filters}
        GET_ENDPOINT={endpoints.SMART_METER_ROLLOUT_UNALLOCATE_GET}
        POST_ENDPOINT={endpoints.SMART_METER_ROLLOUT_UNALLOCATE_POST}
        urlParams={{priority: 'yes'}}
    />
  ]
}
